// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required-icon[data-v-3c674b5b] {\n  color: #ff766e;\n  margin-right: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
